import * as React from "react";
import { Container, Dropdown, Accordion, Card, Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { CustomerService } from "../../Common/Services/CustomerService";
import paginationFactory from 'react-bootstrap-table2-paginator';
import { UserService } from "../../Common/Services/UserService";
import { UserSlideout } from "./UserSlideout";
import _ from "lodash";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { confirmAlert } from "react-confirm-alert";
import createDOMPurify from "dompurify";
 import ToolkitProvider, {
   Search,
 } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
 
import moment from "moment";
const { SearchBar } = Search;
const columns = [
    {
      dataField: 'empCode',
      text: 'Emp. Code',
      sort: true,
    },
   
    {
      dataField: 'firstName',
      text: 'First Name',
      sort: true,
    },
    
    
    {
      dataField: 'lastName',
      text: 'Last Name',
      sort: true,
    },
    {
      dataField: 'roleName',
      text: 'Role',
      sort: true,
    },
    {
        dataField: 'employeeType',
        text: 'Employee Type',
        sort: true,
    },
    {
      dataField: 'userName',
      text: 'User Name',
      sort: true,
    },
    {
      dataField: 'email',
      text: 'Email',
      sort: true,
    },
    {
                           dataField: "locationCode",
                           text: "Location",
                          //  headerStyle: { width: "10%"}, 
                           headerClasses: "text-start pe-4",
                          classes: "text-start pe-4 expanding-bar text-truncate",
                           formatter: (cell: any, row: any, rowIndex: any) => {
                             return (
                              
                               <div className="d-flex align-items-center txt-bold">
                                  <div style={{width: '120px'}}>
                                 <EllipsisWithTooltip placement="bottom">
                                   {row.locationCode}
                                 </EllipsisWithTooltip>
                               </div>
                               </div>
                             );
                           },
                         
                         },
    {
      dataField: 'status',
      text:'Status',
      headerStyle: { width: '200px' },
      headerClasses: 'text-center',
      classes: 'text-center',
      sort: true,
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          
          <>
         
          <EllipsisWithTooltip placement="bottom">
            
              

                <span className={ row.status==="Active" ? "badge badge-pill badge-primary color-green" : "badge badge-pill badge-primary color-red"}> {row.status} </span>


            </EllipsisWithTooltip>
      
      
            </>

        );
    },
  },

  {
    dataField: 'isPermitted',
    text:'',
    headerClasses: 'text-center',
    classes: 'text-center',
    sort: false,
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        
        <>
       
        <EllipsisWithTooltip placement="bottom">
          
            

              <span className={ row.isPermitted=== 1 ? "badge badge-pill badge-primary color-green" : ""}> {row.isPermitted === 1 ? 'Licensed':''} </span>


          </EllipsisWithTooltip>
    
    
          </>

      );
  },
},
     
  ];
  
export class User extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
         
          htmlItem: [],
          htmlErrorItem: [],
          htmlWarningItem: [],
          searcResult: [],
          orderid:0,
          noofusers:2,
        };
        
     
      }
      componentDidMount() {
        let requestlist = { ...this.state.requestlist };
        this.getuserdata(requestlist);
      }


 
      getuserdata = (requestlist: any) => {
 

    UserService.GetUserMaster(requestlist)
    .then(async (result: any[] | null) => {
        console.log(result);
      if (result != null) {
        this.setState({ searcResult: result,noofusers:result[0].noofusers }, () => {
           
        });
      }
      resolve();
    })
    .catch((err: any) => {
      toast.error(`Server Error, ${err}`);
      reject();
    });
  };

  shownewslideout = () => {
debugger;
    // if(this.state.noofusers<this.state.searcResult.length)
    // {

    //   let masg = "";

    //   masg = "Please contact support team at contact@cimmple.com to obtain additional license";

    //   confirmAlert({
    //     title: "Contact Support",

    //     message: masg,
    //     buttons: [
    //       // {
    //       //   label: "Yes",
    //       //   onClick: () => this.reject(file),
    //       // },
    //       {
    //         label: "OK",
    //         onClick: () => reject(),
    //       },
    //     ],

    //     closeOnEscape: false,
    //     closeOnClickOutside: false,
    //   });
    // }
    // else
    // {
    this.setState({ showSlideout: true, templateid: 0 });
    // }
  };

  closeSlideOut = () => {
    this.setState({ showSlideout: false });
    let requestlist = { ...this.state.requestlist };
    this. getuserdata(requestlist);
  };
  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      this.setState({
        showSlideout: true, templateid: row.user_UniqueID

      });


    },
  };

  render() {
    const {

      showSlideout,

    } = this.state; 

    return (
      <>
        <React.Fragment>



          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex">

            Employee
              <div className="action-group d-flex flex-row ml-auto">
              <Button onClick= {this.shownewslideout} >Add Employee</Button>

              </div>
            </div>
            <section className="pb-3">
                <div className="table-responsive divbottom"  >
                  <div className="ml-auto transactions-list mt-2">


                  <ToolkitProvider
                    keyField="id"
                    data={this.state.searcResult}
                    columns={columns}
                    search
                  >
                    {(props) => (
                      <div>
                        <section className="d-flex flex-wrap gap-3 pb-2">
                          <div className="position-relative">
                            <SearchBar {...props.searchProps} />
                          </div>

                          <div>
                            {/* <Form.Label>
                              <SingleDropdownListWithoutSearch
                                itemList={this.state.selectOptions}
                                // handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                defaultItem={this.state.selectedcolumn}
                                defaultText={"Select Filter"}
                                defaultName={this.state.selectedcolumn || "All"}
                                controlID="1"
                                id={"ddlselected"}
                              />
                            </Form.Label> */}
                          </div>
                        </section>
                        <section className="pb-3">
                          <div className="table-responsive divbottom">
                            <div className="ml-auto transactions-list payroll-tbl1">
                              <BootstrapTable
                              {...props.baseProps}
                                                              rowEvents={this.rowEvents}
                                                                keyField="reportGroup"
                                                             // expandRow={expandSplitRow}
                                                            
                              />
                            </div>
                          </div>
                        </section>
                      </div>
                    )}
                  </ToolkitProvider>
            {/* <BootstrapTable
        keyField="id"
        data={this.state.searcResult}
        columns={columns}
        rowEvents={this.rowEvents}
       pagination={ paginationFactory() }
      /> */}
 </div>
                </div>
            

              </section>
      {(showSlideout &&
                <UserSlideout
                  closeSlideOut={this.closeSlideOut}
                  templateid={this.state.templateid}
                >


                </UserSlideout>
              )}






          </Container>



        </React.Fragment>
      </>
    );
  }
}